export class FeaturesView {
  private expandButton: HTMLButtonElement
  private featuresListEl: HTMLElement

  constructor(featureEl: HTMLElement) {
    const featureList = featureEl.querySelector<HTMLElement>('.js-feature-list')
    const expandButton = featureEl.querySelector<HTMLButtonElement>(
      '.js-expand-feature-list'
    )

    if (!featureList) {
      throw new Error('Features View: featureList null')
    }

    if (!expandButton) {
      throw new Error('Features View: expandButton null')
    }

    this.expandButton = expandButton
    this.featuresListEl = featureList

    this.expandButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.expandListOfFeatures()
    })
    this.featuresListEl.addEventListener('click', (event) => {
      event.preventDefault()
      this.shrinkListOfFeatures()
    })
  }

  private expandListOfFeatures() {
    this.featuresListEl.classList.toggle('feature-list--open')
    this.expandButton.classList.toggle('view-more-features--open')
  }

  private shrinkListOfFeatures() {
    this.featuresListEl.classList.toggle('feature-list--open')
    this.expandButton.classList.toggle('view-more-features--open')
  }
}
